import React, { useCallback, useEffect, useState } from "react";
import { getSystemHealth } from "../../services/adminHealthService";
import "./SystemHealth.scss";

function statusLabel(status) {
  if (status === "ok") return "Healthy";
  if (status === "unconfigured") return "Not configured";
  return "Down";
}

function SystemHealth() {
  const [snapshot, setSnapshot] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setError(null);
      const data = await getSystemHealth();
      setSnapshot(data);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Failed to load system health");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, 30000);
    return () => clearInterval(timer);
  }, [refresh]);

  return (
    <div className="system-health">
      <div className="system-health-header">
        <div>
          <h2>System health</h2>
          <p>
            Live checks for the backend process, database, public dashboard, ML worker,
            and WebSocket server. This does not call every write API, so it will not create
            games or send mail.
          </p>
        </div>
        <button type="button" className="admin-btn admin-btn--ghost" onClick={refresh} disabled={loading}>
          {loading ? "Checking…" : "Refresh"}
        </button>
      </div>

      {error && <div className="system-health-error">{error}</div>}

      {snapshot && (
        <>
          <div className={`system-health-overall system-health-overall--${snapshot.overall}`}>
            <strong>{snapshot.overall === "ok" ? "All monitored services are up" : "Something is down"}</strong>
            <span>Last checked {new Date(snapshot.checkedAt).toLocaleTimeString()}</span>
          </div>

          <div className="system-health-grid">
            {(snapshot.checks || []).map((check) => (
              <div key={check.id} className={`system-health-card system-health-card--${check.status}`}>
                <div className="system-health-card-top">
                  <h3>{check.label}</h3>
                  <span className={`system-health-pill system-health-pill--${check.status}`}>
                    {statusLabel(check.status)}
                  </span>
                </div>
                <dl>
                  <div>
                    <dt>Latency</dt>
                    <dd>{check.latencyMs == null ? "—" : `${check.latencyMs} ms`}</dd>
                  </div>
                  {check.httpStatus ? (
                    <div>
                      <dt>HTTP</dt>
                      <dd>{check.httpStatus}</dd>
                    </div>
                  ) : null}
                </dl>
                {check.detail && <p className="system-health-detail">{check.detail}</p>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default SystemHealth;
